var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { css } from '@emotion/react';
import { tokens } from '../tokens';
import { hexToRgba } from '../helpers';
var sizeMap = {
    small: {
        fontSize: tokens.fontSizes.xsmall,
    },
    medium: {
        fontSize: tokens.fontSizes.small,
    },
    large: {
        fontSize: tokens.fontSizes.medium,
    },
    inherit: {
        fontSize: '86%',
    },
};
var baseCodeStyle = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  font-family: ", ";\n  font-weight: ", ";\n  border-radius: ", ";\n  margin: 0 2px;\n  padding: 2px 4px;\n  white-space: nowrap;\n"], ["\n  font-family: ", ";\n  font-weight: ", ";\n  border-radius: ", ";\n  margin: 0 2px;\n  padding: 2px 4px;\n  white-space: nowrap;\n"])), tokens.fontFamilies.mono, tokens.fontWeights.regular, tokens.borderRadius.medium);
export function codeStyle(_a) {
    var size = _a.size, inverted = _a.inverted;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n    mix-blend-mode: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n    background-color: ", ";\n  "], ["\n    ", "\n    mix-blend-mode: ", ";\n    font-size: ", ";\n    line-height: ", ";\n    color: ", ";\n    background-color: ", ";\n  "])), baseCodeStyle, inverted ? 'regular' : 'multiply', sizeMap[size].fontSize, size === 'inherit' ? 'inherit' : tokens.lineHeights.relaxed, inverted ? tokens.colors.white : tokens.colors.navy, inverted
        ? hexToRgba(tokens.colors.white, 0.3)
        : tokens.colors.greyLight);
}
var templateObject_1, templateObject_2;
